export function analisarHemodinamica(chartData) {
  if (!chartData || chartData.length === 0) return null;

  const pasValues = chartData.map((d) => d.PAS);
  const padValues = chartData.map((d) => d.PAD);
  const fcValues = chartData.map((d) => d.FC);

  const pasMax = Math.max(...pasValues);
  const pasMin = Math.min(...pasValues);
  const padMax = Math.max(...padValues);
  const padMin = Math.min(...padValues);
  const fcMax = Math.max(...fcValues);
  const fcMin = Math.min(...fcValues);

  const pasVar = pasMin - pasMax;
  const padVar = padMin - padMax;
  const fcVar = fcMin - fcMax;
  const fcPerc = ((fcVar / fcMax) * 100).toFixed(1);

  const pasAnalysis =
    pasVar <= -20
      ? 'QUEDA SIGNIFICATIVA (sugere hipotensão ortostática)'
      : pasVar < 0
        ? 'Queda discreta'
        : 'Sem queda significativa';

  const padAnalysis =
    padVar <= -10
      ? 'Alteração significativa'
      : padVar < 0
        ? 'Queda discreta'
        : 'Sem alteração importante';

  const fcAnalysis =
    fcVar < 0
      ? `Queda ou ausência de resposta (${fcPerc}%) (avaliar disautonomia)`
      : `Aumento esperado (${fcPerc}%)`;

  return {
    pas: { inicio: pasMax, fim: pasMin, variacao: pasVar, analise: pasAnalysis },
    pad: { inicio: padMax, fim: padMin, variacao: padVar, analise: padAnalysis },
    fc: { inicio: fcMax, fim: fcMin, variacao: fcVar, analise: fcAnalysis },
  };
}

export function normalizeText(s) {
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove acentos
    .replace(/\r\n?/g, '\n') // normaliza CRLF
    .toUpperCase();
}

// Pega o bloco entre um título e o próximo
export function sliceSection(normText, startLabel, otherLabels) {
  const start = normText.indexOf(startLabel);
  if (start === -1) return '';
  let end = normText.length;
  for (const lbl of otherLabels) {
    const idx = normText.indexOf(lbl, start + startLabel.length);
    if (idx !== -1 && idx < end) end = idx;
  }
  return normText.slice(start, end);
}

// Captura o primeiro número após um rótulo (usa rótulo completo e fallback pela sigla)
export function pickValue(block, fullLabel, abbrev) {
  // tenta pelo rótulo completo
  const full = new RegExp(`${fullLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}[^\\d]*(\\d+)`, 'i');
  let m = block.match(full);
  if (!m) {
    // fallback pela sigla (ex.: " PAS)" ou " PAS:")
    const ab = new RegExp(`\\b${abbrev}\\b[^\\d]*(\\d+)`, 'i');
    m = block.match(ab);
  }
  return m ? parseInt(m[1], 10) : null;
}

/**
 * Extrai PAS, PAD, FC de Repouso e Inclinação do texto bruto do laudo.
 * Retorna:
 * {
 *   repouso: { PAS, PAD, FC },
 *   inclinacao: { PAS, PAD, FC }
 * }
 */
export function parseTilt(textoOriginal) {
  if (!textoOriginal) return null;

  const norm = normalizeText(textoOriginal);

  // Labels sem acento (porque normalizamos)
  const L_REP = 'PERIODO DE REPOUSO';
  const L_INC = 'PERIODO DE INCLINACAO';

  const repBlock = sliceSection(norm, L_REP, [L_INC]);
  const incBlock = sliceSection(norm, L_INC, [L_REP]);

  return {
    repouso: {
      PAS: pickValue(repBlock, 'PRESSAO ARTERIAL SISTOLICA (PAS)', 'PAS'),
      PAD: pickValue(repBlock, 'PRESSAO ARTERIAL DIASTOLICA (PAD)', 'PAD'),
      FC: pickValue(repBlock, 'FREQUENCIA CARDIACA (FC)', 'FC'),
    },
    inclinacao: {
      PAS: pickValue(incBlock, 'PRESSAO ARTERIAL SISTOLICA (PAS)', 'PAS'),
      PAD: pickValue(incBlock, 'PRESSAO ARTERIAL DIASTOLICA (PAD)', 'PAD'),
      FC: pickValue(incBlock, 'FREQUENCIA CARDIACA (FC)', 'FC'),
    },
  };
}
